import FacebookAuth from "../components/FacebookAuth";
import GoogleAuth from "../components/GoogleAuth";
import SignUpForm from "../components/SignUpForm";

export default {
  name: "sign_up",

  data() {
    return {};
  },

  methods: {},

  components: {
    FacebookAuth,
    GoogleAuth,
    SignUpForm
  },

  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("signupAgentInfo");
    next();
  }
};
